/* eslint-disable */
import {
  Box,
  styled } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const BoxCmt = styled(Box)(({ theme }) => ({
  width: "500px",
  background: theme.customColors.backgroundPrimary,
  border: `1px solid ${alpha(theme.customColors.border, 0.6)}`,
  borderRadius: "1.25rem",
  padding: "1.5rem 2rem 2rem",
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    width: "375px",
    padding: "1.5rem"
  },
}));
